import lodash from 'lodash';

export const getState = (state, param = null, defaultValue = null) => lodash.get(state, 'inventory.historyList' + (param ? '.' + param : ''), defaultValue);
